import type { ActivityRow } from '../../core';
import { FieldChangeRow } from './FieldChangeRow';
import { TableChangeRow } from './TableChangeRow';

export const renderFieldRow = (row: ActivityRow) => {
  switch (row.kind) {
    case 'field':
      return (
        <FieldChangeRow
          label={row.label}
          previousValue={row.previousValue}
          value={row.value}
        />
      );
    case 'table':
      return <TableChangeRow label={row.label} rows={row.rows} />;
    default:
      return null;
  }
};
